var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagPop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 30,
    width: 62,
    height: 12,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 13,
    fill: "#1e50a0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 4,
    height: 4,
    fill: "#2e7bd8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 20,
    height: 4,
    fill: "#3083e8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 18,
    width: 4,
    height: 4,
    fill: "#3082e7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    width: 4,
    height: 4,
    fill: "#2e7ad6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 4,
    height: 4,
    fill: "#2f7fe0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 4,
    height: 4,
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 22,
    width: 4,
    height: 4,
    fill: "#121111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 22,
    width: 4,
    height: 4,
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 22,
    width: 4,
    height: 4,
    fill: "#2e7ddd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 22,
    width: 4,
    height: 4,
    fill: "#191818"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 22,
    width: 4,
    height: 4,
    fill: "#282727"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 22,
    width: 4,
    height: 4,
    fill: "#3080e1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26,
    width: 4,
    height: 4,
    fill: "#3790fd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26,
    width: 4,
    height: 4,
    fill: "#2e7ddd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 26,
    width: 4,
    height: 4,
    fill: "#2d79d6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 4,
    height: 4,
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 26,
    width: 4,
    height: 4,
    fill: "#3183e8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 26,
    width: 4,
    height: 4,
    fill: "#3489f1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 26,
    width: 4,
    height: 4,
    fill: "#2f7edf"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 26,
    width: 4,
    height: 4,
    fill: "#3690fd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 4,
    height: 4,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 30,
    width: 4,
    height: 4,
    fill: "#656464"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 30,
    width: 4,
    height: 4,
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 30,
    width: 8,
    height: 4,
    fill: "#565252"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 30,
    width: 4,
    height: 4,
    fill: "#201f1f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 30,
    width: 4,
    height: 4,
    fill: "#5f5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 30,
    width: 4,
    height: 4,
    fill: "#131212"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 34,
    width: 4,
    height: 4,
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 34,
    width: 4,
    height: 4,
    fill: "#0e0e0e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 34,
    width: 4,
    height: 4,
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34,
    width: 4,
    height: 4,
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 34,
    width: 4,
    height: 4,
    fill: "#090808"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 34,
    width: 4,
    height: 4,
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 34,
    width: 4,
    height: 4,
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 34,
    width: 4,
    height: 4,
    fill: "#646363"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 38,
    width: 4,
    height: 4,
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 38,
    width: 4,
    height: 4,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 38,
    width: 4,
    height: 4,
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 38,
    width: 4,
    height: 4,
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 38,
    width: 4,
    height: 4,
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 38,
    width: 4,
    height: 4,
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 38,
    width: 4,
    height: 4,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 38,
    width: 4,
    height: 4,
    fill: "#545151"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 42,
    width: 4,
    height: 4,
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 42,
    width: 4,
    height: 4,
    fill: "#0d0c0c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 42,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 42,
    width: 4,
    height: 4,
    fill: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 42,
    width: 4,
    height: 4,
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 42,
    width: 4,
    height: 4,
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 42,
    width: 4,
    height: 4,
    fill: "#f9f6f6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 42,
    width: 4,
    height: 4,
    fill: "#d7d2d2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 46,
    width: 4,
    height: 4,
    fill: "#e1e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 46,
    width: 4,
    height: 4,
    fill: "#fdfcfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 46,
    width: 4,
    height: 4,
    fill: "#dad5d5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 46,
    width: 4,
    height: 4,
    fill: "#fdfafa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 46,
    width: 4,
    height: 4,
    fill: "#e9dfdf"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 46,
    width: 4,
    height: 4,
    fill: "#fcf9f9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 46,
    width: 4,
    height: 4,
    fill: "#d9d5d5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 46,
    width: 4,
    height: 4,
    fill: "#fcfcfc"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPop);
export default __webpack_public_path__ + "static/media/flag_pop.431e7ad360e83cc68732a387bc1c6e2e.svg";
export { ForwardRef as ReactComponent };